module.exports = __webpack_public_path__ + "img/mentor.dd876b1a.jpeg";